import { useEffect } from "react";
import { createChat } from "@n8n/chat";
import "@n8n/chat/style.css";
import "./App.css";

export const App = () => {
  useEffect(() => {
    createChat({
      webhookUrl:
        "https://build.gjurchevski.com/webhook/e104e40e-6134-4825-a6f0-8a646d882662/chat",
      mode: "fullscreen", // To make it fullscreen
      showWelcomeScreen: true, // Enable the welcome screen
      initialMessages: [
        "Hallo! 👋\n\nMein Name ist TorWe. Wie kann ich Ihnen heute helfen?",
      ], // Customize initial messages
      i18n: {
        en: {
          // title: "Cao! 👋", // Customize the title
          //subtitle: "We are available to assist you.", // Customize subtitle
          inputPlaceholder: "Stellen Sie Ihre Frage...", // Change input placeholder text
        },
      },
    });

    // Modify the existing button and content instead of recreating it
    const chatGetStarted = document.querySelector(".chat-get-started");
    const existingButton = document.querySelector(".chat-button");

    if (chatGetStarted && existingButton) {
      // Modify title, description, and keep the original button event listener
      chatGetStarted.insertAdjacentHTML(
        "beforeend",
        `
      <div class="chat-content">
        <h1 class="chat-title">Erleben Sie mühelose Effizienz durch Ihren neuen KI-Assistenten</h1>
        <p class="chat-description">Erleben Sie erhebliche Zeiteinsparungen und gesteigerte Effizienz in Ihrem Unternehmen mit einem intelligenten KI-Agenten.</p>
      </div>
    `
      );

      // Update the button text to "Neue Konversation"
      existingButton.textContent = "Neue Konversation";

      // Move the button to be under the description
      const chatContent = document.querySelector(".chat-content");
      chatContent.appendChild(existingButton);
    }

    // Change the "Powered by" text
    const poweredByDiv = document.querySelector(".chat-powered-by");
    if (poweredByDiv) {
      poweredByDiv.innerHTML = "Copyright © 2024 i-Gentic"; // Update the text here
    }
  }, []);

  return <div id="n8n-chat-container"></div>;
};
